import PropTypes from "prop-types";

export default PropTypes.shape({
	id: PropTypes.number,
	type: PropTypes.number,
	balance: PropTypes.number,
	minBalance: PropTypes.number,
	maxBalance: PropTypes.number
});
